'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _toConsumableArray = _interopDefault(require('babel-runtime/helpers/toConsumableArray'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var Popover = _interopDefault(require('./popover.js'));

// easing curve for slide transition
_Object$assign($.easing, {
  easeInOutSine: function easeInOutSine(x) {
    return -1 / 2 * (Math.cos(Math.PI * x) - 1);
  }
});

function Nav(options) {
  var selectors = {
    wrapper: '.marketing-nav-wrapper',
    subNavList: '#ShopifySubNavList',
    mobileSelect: '#ShopifyNavMobileSelect',
    dropdown: '.js-popover-dropdown',
    flyout: '.js-popover-flyout'
  };

  this.config = options || {};
  this.config.selectors = this.config.selectors ? _Object$assign(this.config.selectors, selectors) : selectors;

  this.$wrapper = $(this.config.selectors.wrapper);

  if (!this.$wrapper.length) {
    return false;
  }

  this.$subNavList = $(this.config.selectors.subNavList);
  this.$mobileSelect = $(this.config.selectors.mobileSelect);

  this.dropdownEls = document.querySelectorAll([this.config.selectors.wrapper, this.config.selectors.dropdown].join(' '));

  this.init();
}

Nav.prototype.init = function () {
  this.initDropdowns();
  this.$mobileSelect.on('click', this.toggleSubnav.bind(this));
};

Nav.prototype.initDropdowns = function () {
  var _this = this;

  this.dropdowns = [].concat(_toConsumableArray(this.dropdownEls)).map(function (dropdownEl) {
    var dropdown = new Popover(dropdownEl);
    var flyoutEls = dropdownEl.querySelectorAll(_this.config.selectors.flyout);

    dropdown.flyouts = [].concat(_toConsumableArray(flyoutEls)).map(function (flyoutEl) {
      // eslint-disable-next-line no-new
      return new Popover(flyoutEl, {
        onShow: function onShow() {
          var popoverListMinHeight = flyoutEl.querySelector('.popover-content').offsetHeight;

          dropdown.$popover.addClass('has-active-flyout');
          dropdown.$popover[0].querySelector('.popover-content__list').setAttribute('style', 'min-height:' + popoverListMinHeight + 'px');
        },
        onHide: function onHide() {
          dropdown.$popover.removeClass('has-active-flyout');
        }
      });
    });

    return dropdown;
  });
};

Nav.prototype.toggleSubnav = function () {
  var newState = !this.$wrapper.hasClass('js-is-active');

  this.$mobileSelect.attr('aria-expanded', newState);
  this.$wrapper.toggleClass('js-is-active');
  this.$subNavList.slideToggle({
    easing: 'easeInOutSine',
    duration: 300
  });
};

module.exports = Nav;
